import { useState } from 'react';

import { TechnicalTypeSortBy } from 'src/helpers/filterTechnicalTypes';
import { PublishedFilter } from 'src/helpers/publishedFilter';
import { EOrder } from 'src/interfaces/Order';

export function useTechnicalTypeListFilters() {
  const [query, setQuery] = useState('');
  const [publishedFilter, setPublishedFilter] = useState<PublishedFilter>('all');
  const [order, setOrder] = useState<EOrder>(EOrder.asc);
  const [orderByKey, setOrderByKey] = useState<TechnicalTypeSortBy>('label');

  return {
    query,
    publishedFilter,
    order,
    orderByKey,
    setQuery,
    setPublishedFilter,
    setOrder,
    setOrderByKey,
  };
}
